import React from 'react';

/**
 * Единый источник loading / empty / error состояний модуля.
 * ТЗ раздел 10: состояния не должны подменять друг друга, а сетевые ошибки
 * нельзя показывать как пустой список.
 */
const ViolationStateBlock = ({ state, message, onRetry, onReset, children }) => {
  if (state === 'loading') {
    return (
      <div className="vio-state vio-state--loading" role="status" aria-live="polite">
        <span className="vio-visually-hidden">Загрузка</span>
        <div className="vio-skeleton-row" />
        <div className="vio-skeleton-row" />
        <div className="vio-skeleton-row" />
        <div className="vio-skeleton-row" />
        <div className="vio-skeleton-row" />
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="vio-state vio-state--error">
        <p className="vio-state-text">{message || 'Не удалось загрузить данные'}</p>
        {onRetry && (
          <button type="button" className="vio-btn vio-btn--primary" onClick={onRetry}>
            Повторить
          </button>
        )}
      </div>
    );
  }

  if (state === 'empty') {
    return (
      <div className="vio-state vio-state--empty">
        <p className="vio-state-text">{message}</p>
        {children}
        {onReset && (
          <button type="button" className="vio-btn" onClick={onReset}>
            Сбросить фильтры
          </button>
        )}
      </div>
    );
  }

  return null;
};

export default ViolationStateBlock;
